<template>
    <q-card class="debug-dialog-card">
        <q-toolbar class="text-white debug-dialog-toolbar flex-shrink-0">
            <q-toolbar-title class="text-white">
                Debug Form
            </q-toolbar-title>

            <q-space />

            <q-btn
                flat
                round
                dense
                color="white"
                icon="mdi-close-box"
                @click="closeForm"
            />
        </q-toolbar>

        <q-card-section class="debug-dialog-body q-pt-none">
            <q-tabs
                v-model="debug_tab_selected"
                class="debug-dialog-tabs q-mb-sm flex-shrink-0"
                dense
                align="left"
                active-color="primary"
                indicator-color="primary"
            >
                <q-tab name="0" label="Model" />
                <q-tab name="1" label="Schema" />
                <q-tab name="2" label="Form" />
            </q-tabs>

            <div class="debug-editor-host">
                <AceEditor
                    lang="json"
                    theme="github"
                    :read-only="true"
                    :font-size="13"
                    :content="activeJson"
                    @init="onAceInit"
                />
            </div>
        </q-card-section>
    </q-card>
</template>

<script>
    import { nextTick } from 'vue';
    import AceEditor from '../3rdParty/AceEditor.jsx';

    const getCircularReplacer = () => {
        const seen = new WeakSet();
        return (key, value) => {
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) {
                    return;
                }
                seen.add(value);
            }
            return value;
        };
    };

    export default {
        name: 'debug-dialog',
        components: {
            AceEditor,
        },
        data: function () {
            return {
                debug_tab_selected: '0',
                aceEditor: null,
            };
        },
        props: {
            schema: null,
            form: null,
            cmodel: null,
        },
        computed: {
            activeJson() {
                const tab = this.debug_tab_selected;
                if (tab === '1') {
                    return this.stringifyForTab(this.schema || {});
                }
                if (tab === '2') {
                    return this.stringifyForTab(this.form || []);
                }
                return this.stringifyForTab(this.cmodel || {});
            },
        },
        watch: {
            debug_tab_selected() {
                this.scheduleAceResize();
            },
            activeJson() {
                this.scheduleAceResize();
            },
        },
        methods: {
            stringifyForTab(obj) {
                return JSON.stringify(obj, getCircularReplacer(), 4);
            },
            onAceInit(editor) {
                this.aceEditor = editor;
                nextTick(() => this.resizeAce());
            },
            scheduleAceResize() {
                nextTick(() => this.resizeAce());
            },
            resizeAce() {
                this.aceEditor?.resize?.();
            },
            closeForm() {
                this.$emit('closeme');
            },
        },
    };
</script>

<style scoped>
    .debug-dialog-card {
        width: 100%;
        flex: 1 1 auto;
        min-height: 0;
        max-height: 100%;
        display: flex;
        flex-direction: column;
    }

    .debug-dialog-toolbar {
        background-color: var(--v-navigation-base);
        min-height: 60px;
        height: 60px;
    }

    .debug-dialog-body {
        display: flex;
        flex-direction: column;
        flex: 1 1 0;
        min-height: 0;
        overflow: hidden;
    }

    .debug-dialog-tabs {
        flex-shrink: 0;
    }

    .debug-editor-host {
        flex: 1 1 0;
        min-height: 0;
        min-width: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
</style>
